import { render, staticRenderFns } from "./CmgRewardExtrasCampaignDetailModal.vue?vue&type=template&id=1553a7df&scoped=true&lang=pug&"
import script from "./cmg-reward-extras-campaign-detail-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-reward-extras-campaign-detail-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardExtrasCampaignDetailModal.vue?vue&type=style&index=0&id=1553a7df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553a7df",
  null
  
)

export default component.exports